import React from "react";

import "./style.scss";

import {
	Typography,
	Link,
	Stack,
} from "@mui/material";

import { Trans } from "@lingui/macro";
import { ActionFigureProps } from "./models";
import IconComp from "commons/icon-comp/icon-comp";

export class ActionFigure extends React.Component<ActionFigureProps, {}>
{

	render() {
		return (<>
				<Link href={this.props.href} sx={{textDecoration: "none"}} className="figure-container">
						<Stack spacing={1}>
								<IconComp icon={this.props.icon} color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}/>
								<Typography variant="h3" textAlign="center" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
										<Trans id={this.props.descriptionId}>{this.props.description}</Trans>
								</Typography>
						</Stack>
				</Link>
		</>);
	}
}
